import createSagaMiddleware from '@redux-saga/core';
import { configureStore } from '@reduxjs/toolkit';
import rootSaga from './root-saga';
import rootReducers from './root-reducer';
var sagaMiddleware = createSagaMiddleware();
var store = configureStore({
    reducer: rootReducers,
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware().concat(sagaMiddleware);
    },
});
sagaMiddleware.run(rootSaga);
export default store;
